var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isWebComponentEnvironment } from '@/helpers';
export var languages = __spreadArray(__spreadArray([
    {
        id: 'en',
        name: 'Englisch (EN)'
    }
], __read((isWebComponentEnvironment() ? [{ id: 'en-US', name: 'English (EN)' }] : [])), false), [
    {
        id: 'de',
        name: 'Deutsch (DE)'
    },
    {
        id: 'cs',
        name: 'Czech (CS)'
    },
    {
        id: 'da',
        name: 'Danish (DA)'
    },
    {
        id: 'es',
        name: 'Spanish (ES)'
    },
    {
        id: 'fi',
        name: 'Finnish (FI)'
    },
    {
        id: 'fr',
        name: 'French (FR)'
    },
    {
        id: 'hu',
        name: 'Hungarian (HU)'
    },
    {
        id: 'it',
        name: 'Italian (IT)'
    },
    {
        id: 'ja',
        name: 'Japanese (JA)'
    },
    {
        id: 'ko',
        name: 'Korean (KO)'
    },
    {
        id: 'nb',
        name: 'Norwegian (NB)'
    },
    {
        id: 'nl',
        name: 'Netherlands (NL)'
    },
    {
        id: 'pl',
        name: 'Polish (PL)'
    },
    {
        id: 'pt',
        name: 'Portuguese (PT)'
    },
    {
        id: 'ru',
        name: 'Russian (RU)'
    },
    {
        id: 'sv',
        name: 'Swedish (SV)'
    },
    {
        id: 'tr',
        name: 'Turkish (TR)'
    },
    {
        id: 'zh',
        name: 'Chinese (ZH)'
    }
], false);
